<template>
  <a v-if="(lat && lng) || url"
     :href="urlValue"
     class="streetview"
     target="_blank"
  >
    <slot>
      <img v-if="imageSize"
           class="streetview__image"
           :src="imageSrc"
           @load="loading = false"
           @error="onError"
      />
    </slot>

    <span v-if="loading" class="content-loader">
      <Spinner />
    </span>
  </a>
</template>
<script setup>
import {computed, ref} from "vue";
import Spinner from "@/js/Elements/Spinner.vue";
import {useStore} from "vuex";
import DefaultImage from '@/css/images/streetview.jpg';

const props = defineProps({
  lat: Number,
  lng: Number,
  course: Number,
  imageSize: String,
  url: String,
});
const store = useStore();
const courseValue = computed(() => Math.round(props.course));
const loading = ref(!!props.imageSize);
const error = ref(false);
const urlValue = computed(() => {
  return props.url || `https://maps.google.com/maps?q=&layer=c&cbll=${props.lat},${props.lng}&cbp=11,${courseValue.value ? courseValue.value + ',' : ''}0,0,0`;
});
const imageSrc = computed(() => {
  if (error.value) {
    return DefaultImage;
  }

  return `/ui/streetview.jpg?size=${props.imageSize}&amp;location=${props.lat},${props.lng}&amp;heading=${props.course}`;
});

function onError(err) {
  error.value = true;
  loading.value = false;
}
</script>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";

.streetview {
  position: relative;
  &__image,
  &__error {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__error {
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>